import React from 'react';
import Graph from "react-graph-vis";
import './depgraph.css';
import { Button } from '@blueprintjs/core';

export default class DependencyGraph extends React.Component {

    constructor(props) {
        super(props);
        this.graphKey = 0;
        this.onThemeChanged = this.onThemeChanged.bind(this);
    }

    componentDidMount() {
        document.addEventListener("themeChange", this.onThemeChanged);
    }

    componentWillUnmount() {
        document.removeEventListener("themeChange", this.onThemeChanged);
    }

    onThemeChanged(event) {
        this.forceUpdate();
    }
        
    buildGraph() {
        const graph = {nodes: [], edges: []};
        if (this.props.instrList) {
            // adding nodes
            this.props.instrList.forEach((instr,ix) => {
                if (instr.error==="")
                    graph.nodes.push({
                        id: instr.line,
                        label: "i"+instr.line
                    });
            });
            // adding RAW dependencies
            for (let i=0; i<this.props.instrList.length; i++) {
                if (this.props.instrList[i].regA)
                    for (let j=i-1; j>=0; j--)
                        if (this.props.instrList[i].regA===this.props.instrList[j].targetReg) {
                            graph.edges.push({
                                to: this.props.instrList[j].line,
                                from: this.props.instrList[i].line,
                                label: `RAW (${this.props.instrList[i].regA})`
                            });
                            break;
                        }
                if (this.props.instrList[i].regB)
                    for (let j=i-1; j>=0; j--)
                        if (this.props.instrList[i].regB===this.props.instrList[j].targetReg) {
                            graph.edges.push({
                                to: this.props.instrList[j].line,
                                from: this.props.instrList[i].line,
                                label: `RAW (${this.props.instrList[i].regB})`
                            });
                            break;
                        }    
            }
            // adding WAW dependencies
            for (let i=0; i<this.props.instrList.length; i++) {
                if (this.props.instrList[i].targetReg)
                    for (let j=i-1; j>=0; j--)
                        if (this.props.instrList[i].targetReg===this.props.instrList[j].targetReg) {
                            const hit = graph.edges.find(e => e.to === this.props.instrList[j].line && e.from === this.props.instrList[i].line);
                            if (!hit)
                                graph.edges.push({
                                    to: this.props.instrList[j].line,
                                    from: this.props.instrList[i].line,
                                    label: `WAW (${this.props.instrList[i].targetReg})`
                                });
                            else
                                hit.label += `, WAW (${this.props.instrList[i].targetReg})`
                            break;
                        }
            }
            // adding WAR dependencies
            for (let i=0; i<this.props.instrList.length; i++) {
                if (this.props.instrList[i].targetReg)
                    for (let j=i-1; j>=0; j--)
                        if (this.props.instrList[i].targetReg===this.props.instrList[j].regA || this.props.instrList[i].targetReg===this.props.instrList[j].regB) {
                            const hit = graph.edges.find(e => e.to === this.props.instrList[j].line && e.from === this.props.instrList[i].line);
                            if (!hit)
                                graph.edges.push({
                                    to: this.props.instrList[j].line,
                                    from: this.props.instrList[i].line,
                                    label: `WAR (${this.props.instrList[i].targetReg})`
                                });
                            else
                                hit.label += `, WAR (${this.props.instrList[i].targetReg})`
                            break;
                        }
            }
        }
        return graph;
    }

    render() {
        this.graphKey += 1;
        const options = {
            edges: {
                color: getComputedStyle(document.querySelector('body')).getPropertyValue("--main-fg-color"),
                width: 2,
                font: {
                    color: getComputedStyle(document.querySelector('body')).getPropertyValue("--main-fg-color"),
                    strokeColor: getComputedStyle(document.querySelector('body')).getPropertyValue("--main-frame-bg-color"),
                    strokeWidth: 4
                },
                smooth: true
            },        
            nodes: {
                color: getComputedStyle(document.querySelector('body')).getPropertyValue("--main-emph-light-color"),
                font: {
                    size: 16
                }
            },
            physics: {
                solver: "forceAtlas2Based"
            },
            interaction: {
                zoomView: false
            },
            height: "400px"
        };
        return <div className="dependency-graph-container">
            <Graph
                key={this.graphKey}
                options={options}
                graph={this.buildGraph()}        
            />
            <Button 
                icon="refresh"
                minimal="true"
                text=""
                className="dependency-graph-update-button"
                onClick={() => this.forceUpdate()} 
            />
        </div>;
    }
};